import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import AuditionStore from './store';
import Link from '@src/components/link';
import cx from 'classnames';
import $$tracker from '@src/tracker';

const styles = require('./index.less');

const Audition = ({ store }) => {
  store.use();

  return (
    <div className={styles.audition}>
      <div className={styles.auditionList}>
        {store.auditionList.map(item => (
          <div
            className={styles.auditionItem}
            key={item.id}
            onClick={() => {
              $$tracker.clickStzx(item.name);
              store.clickNavigate(item.link);
            }}
          >
            <img src={item.bg} alt="" className={styles.bg} data-name="中心图案-置灰" />
            <div className={styles.mask} />
            <img src={item.icon} alt="" className={styles.centerIcon} data-name="中心图案-置灰" />
            <div className={styles.centerTitle}>
              <div className={styles.title} style={{ backgroundImage: `url(${item.title})` }} />
              <div className={cx(styles.title, styles.titleBottom)} style={{ backgroundImage: `url(${item.title})` }} />
            </div>

            <img src={item.titleLight} alt="" className={styles.titleLight} data-name="标题-高亮" />
            <Link className={styles.more} data-name="查看更多-高亮" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default wrapStore(Audition, AuditionStore);
